import { Skeleton } from "@/components/ui/skeleton";

export default function PrintableSummarySkeleton() {
  return (
    <div className="min-h-screen bg-linen px-6 py-10" role="status" aria-label="Preparing deal summary">
      <div className="mx-auto max-w-[850px] bg-white p-8 shadow-xl sm:p-12">
        <div className="flex justify-between gap-6 border-b border-edge pb-8"><div className="flex-1"><Skeleton className="h-3 w-24" /><Skeleton className="mt-3 h-9 w-3/5" /><Skeleton className="mt-3 h-4 w-2/5" /></div><Skeleton className="size-16 rounded-full" /></div>
        <div className="grid gap-8 py-8 sm:grid-cols-2">{[0, 1, 2, 3, 4, 5].map((item) => <div key={item}><Skeleton className="h-3 w-28" /><Skeleton className="mt-3 h-6 w-4/5" /><Skeleton className="mt-2 h-4 w-3/5" /></div>)}</div>
        <div className="border-t border-edge pt-8"><Skeleton className="h-5 w-40" />{[0, 1, 2].map((item) => <Skeleton key={item} className="mt-4 h-4 w-full" />)}</div>
        <span className="sr-only">Formatting printable contract terms…</span>
      </div>
    </div>
  );
}
